module.exports = __webpack_public_path__ + "static/media/elo_white.d293530c.png";